import { IDataTh, ThCoreIndex } from "src/Pages/components";

export const THeadContractsFiles = () => {
  const dataTh: IDataTh[] = [
    {
      title: "Ações",
      width: "40px",
      align: "left",
    },
    {
      title: "Arquivos",
      align: "left",
      width: "500px",
    },
    {
      title: "Tamanho",
      align: "left",
      width: "100px",
    },
    {
      title: "Data de criação",
      align: "left",
      width: "100px",
    },
    {
      title: "Visualizar",
      align: "center",
      width: "50px",
    },
  ];

  return <ThCoreIndex dataTh={dataTh} />;
};
